import React, { useState, useRef, useEffect } from "react";
import TYPE from "../../../constant/TYPE";
import { getMathJaxNode } from "../mathjax/MathJax";

const IntervalTable = ( props ) => {

  const [ width, setWidth ] = useState( 0 );
  const [ renderKey, setRenderKey ] = useState( 0 );

  const prevData = useRef( [] );
  const originWidths = useRef( {} );
  const mathjaxRenderCount = useRef( 0 );

  const startKeyword = `\\begin{${ TYPE.LATEX_CODE.INTERVAL_TABLE }}`;
  const endKeyword = `\\end{${ TYPE.LATEX_CODE.INTERVAL_TABLE }}`;
  const data = props.children.slice( props.children.indexOf( startKeyword ) + startKeyword.length, props.children.indexOf( endKeyword ) ).split( '\\\\' ).map( v => v.split( '&' ).map( v => v.trim() ) );
  const changedDataCount = data.reduce( ( r, v, i ) => r + v.filter( ( vv, ii ) => ( prevData.current[ i ] && prevData.current[ i ][ ii ] ) !== vv ).length, 0 );

  const MathJaxNode = getMathJaxNode( props.type );

  let rowIndex;

  useEffect( () => {
    renderKey && props.onRender();
  }, [ renderKey, props.onRender ] );

  const mapRows = ( value, index ) => {
    rowIndex = index;
    return <tr key={ index } className={ `spaceline-list-${ index === 0 ? 'up' : 'down' }` }>{ value.map( mapColumns ) }</tr>;
  };

  const mapColumns = ( value, index ) => {
    return (
      <td key={ index } className="tape-table-td" style={ { width } }>
        <span className="inputTxt"><MathJaxNode index={ `${ rowIndex }-${ index }` } onRender={ renderMathJax }>{ value }</MathJaxNode></span>
      </td>
    );
  };

  const renderMathJax = ( target, index ) => {
    mathjaxRenderCount.current++;
    originWidths.current[ index ] = target.parentNode.offsetWidth;
    if ( changedDataCount === mathjaxRenderCount.current ) {
      prevData.current = data;
      mathjaxRenderCount.current = 0;
      setWidth( getWidth() );
      setRenderKey( Date.now() );
    }
  };

  const getWidth = () => {
    let width = 0;
    for ( let i in originWidths.current ) {
      if ( width < originWidths.current[ i ] ) {
        width = originWidths.current[ i ];
      }
    }
    return Math.ceil( width + 20 );
  };

  const ROWS = data.map( mapRows );
  const LINE = <tr className="lineTR">{ data[ 0 ].map( ( v, i ) => <td key={ i }><span className="line" /></td> ) }</tr>;

  return (
    <table className="tbl-spaceline-list" style={ { width : width * data[ 0 ].length } }>
      <tbody>
      { ROWS[ 0 ] }
      { LINE }
      { ROWS[ 1 ] }
      </tbody>
    </table>
  );

};

export default IntervalTable;
